<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <base-material-card icon="mdi-account-group">
          <v-row>
            <v-col>
              <v-tabs v-model="tab">
                <v-tab>Pelaporan Kinerja</v-tab>
                <v-tab :disabled="!canOpenKeberatan">
                  Pengajuan Keberatan
                  <v-icon v-if="!canOpenKeberatan" small right>mdi-lock</v-icon>
                </v-tab>
              </v-tabs>
            </v-col>
          </v-row>

          <v-tabs-items v-model="tab">
            <v-tab-item>
              <PelaporanKinerjaAsn />
            </v-tab-item>
            <v-tab-item>
              <KeberatanKinerja v-if="canOpenKeberatan" />
            </v-tab-item>
          </v-tabs-items>
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import PelaporanKinerjaAsn from "@/views/TindakLanjut/components/PelaporanKinerjaAsn";
import KeberatanKinerja from "@/views/TindakLanjut/components/KeberatanKinerja";

export default {
  name: "PelaporanKinerja",
  components: {
    PelaporanKinerjaAsn,
    KeberatanKinerja,
  },
  data() {
    return {
      tab: 0,
      // set false untuk membuka tab keberatan
      keberatanLocked: true,
    };
  },
  computed: {
    erkYear() {
      return parseInt((this.$store.getters["user/current"] || {}).year, 10) || 0;
    },
    isKeberatanYear() {
      return this.erkYear >= 2026;
    },
    canOpenKeberatan() {
      return !this.keberatanLocked && this.isKeberatanYear;
    },
  },
  watch: {
    canOpenKeberatan(val) {
      if (!val && this.tab === 1) this.tab = 0;
    },
  },
};
</script>
